"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyProfileTeamSiteService = void 0;
var CommonService_decorator_1 = require("../../core/decorators/CommonService.decorator");
/*
This LegacyProfileTeamSiteService is used to replace the profile and teamsite
related props in $App and commonHelper.$App
*/
var LegacyProfileTeamSiteService = /** @class */ (function () {
    function LegacyProfileTeamSiteService() {
    }
    Object.defineProperty(LegacyProfileTeamSiteService.prototype, "profileVersionId", {
        get: function () {
            return this._profileVersionId;
        },
        set: function (value) {
            this._profileVersionId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LegacyProfileTeamSiteService.prototype, "teamSiteId", {
        get: function () {
            return this._teamSiteId;
        },
        set: function (value) {
            this._teamSiteId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LegacyProfileTeamSiteService.prototype, "profileId", {
        get: function () {
            return this._profileId;
        },
        set: function (value) {
            this._profileId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LegacyProfileTeamSiteService.prototype, "profileVersionIdNewsCenter", {
        get: function () {
            return this._profileVersionIdNewsCenter;
        },
        set: function (value) {
            this._profileVersionIdNewsCenter = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LegacyProfileTeamSiteService.prototype, "teamSiteIdInContentManager", {
        get: function () {
            return this._teamSiteIdInContentManager;
        },
        set: function (value) {
            this._teamSiteIdInContentManager = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LegacyProfileTeamSiteService.prototype, "folderName", {
        get: function () {
            return this._folderName;
        },
        set: function (value) {
            this._folderName = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LegacyProfileTeamSiteService.prototype, "workspaceProfileVersionId", {
        get: function () {
            return this._workspaceProfileVersionId;
        },
        set: function (value) {
            this._workspaceProfileVersionId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LegacyProfileTeamSiteService.prototype, "defaultProfileVersionId", {
        get: function () {
            return this._defaultProfileVersionId;
        },
        set: function (value) {
            this._defaultProfileVersionId = value;
        },
        enumerable: false,
        configurable: true
    });
    LegacyProfileTeamSiteService = __decorate([
        CommonService_decorator_1.CommonService('LegacyProfileTeamSiteService')
    ], LegacyProfileTeamSiteService);
    return LegacyProfileTeamSiteService;
}());
exports.LegacyProfileTeamSiteService = LegacyProfileTeamSiteService;
//# sourceMappingURL=LegacyProfileTeamSite.service.js.map